


















































































































import Vue, { PropType } from "vue";
import ModListUserBodyRolesComp from "./ModListUserBodyRolesComp.vue";
import ModListUserGuildLogComp from "./ModListUserGuildLogComp.vue";
import ModListUserEditComp from "./ModListUserEditComp.vue";
import moderation from "../../services/endpoints/moderation";
import { User } from "models/Types";
import { DiscordMember } from "models/Discord";

export default Vue.extend({
	name: "ModListUserBodyComp",
	components: { ModListUserEditComp, ModListUserGuildLogComp, ModListUserBodyRolesComp },
	data: () => ({
		archiveDialog: false,
		restoreDialog: false,
		dateOptions: { dateStyle: "medium", timeStyle: "medium" } as Intl.DateTimeFormatOptions,
	}),
	props: {
		user: Object as PropType<User>,
	},
	computed: {
		hasDiscord: function(): boolean {
			return !!this.user.discord;
		},
		isInGuild: function(): boolean {
			return !!this.user.guild;
		},
		discordJoinDate: function(): string {
			if (this.hasDiscord) {
				const date = new Date((this.user.discord as DiscordMember).joined);
				return date.toLocaleString("de-DE", this.dateOptions);
			} else {
				return "";
			}
		},
		guildJoinDate: function(): string {
			if (this.isInGuild) {
				const date = new Date(this.user.guild.joined);
				return date.toLocaleString("de-DE", this.dateOptions);
			} else {
				return "";
			}
		},
		archiveDate: function(): string {
			if (this.user.archived) {
				return this.user.archiveDate.toLocaleString("de-DE", this.dateOptions);
			} else {
				return "";
			}
		},
		lastActive: function(): string {
			if (!this.user.lastActive) return "Keine Aufzeichnung";
			const date = Number(new Date(this.user.lastActive));
			const diff = Number(new Date()) - date;
			const minutes = Math.ceil(diff / (1000 * 60));
			if (minutes === 1) return "gerade eben";
			else if (minutes < 60) return `vor ${minutes} Minuten`;
			const hours = Math.floor(minutes / 60);
			if (hours === 1) return "vor 1 Stunde";
			else if (hours < 24) return `vor ${hours} Stunden`;
			const days = Math.floor(hours / 24);
			if (days === 1) return "vor 1 Tag";
			else return `vor ${days} Tagen`;
		},
		firstTermin: function(): string {
			return this.parseDate(this.user.firstTermin);
		},
		lastTermin: function(): string {
			return this.parseDate(this.user.lastTermin);
		},
		hasExtraAccounts: function(): boolean {
			return !!this.user.extraAccounts && this.user.extraAccounts.length > 0;
		},
		comment: function(): string {
			return this.user.comment;
		}
	},
	methods: {
		openLink: function(): void {
			this.$router.push(`/profil/${this.user.id}`);
		},
		parseDate: function(dateString: any): string {
			if (dateString) {
				const date = new Date(dateString);
				const dateOptions: any = { day: "2-digit", month: "2-digit", year: "numeric" };
				return date.toLocaleDateString("de-DE", dateOptions);
			} else {
				return "Nie";
			}
		},
		archive: async function(): Promise<void> {
			const archiveDate = await moderation.archiveSpieler(this.user.id);
			this.$emit("userArchived", this.user.id, archiveDate);
			this.archiveDialog = false;
		},
		commentUpdated: function(userId: number, comment: string): void {
			this.$emit("commentUpdated", userId, comment);
		},
		restore: async function(): Promise<void> {
			await moderation.restoreUser(this.user.id);
			this.$emit("userRestored", this.user.id);
		},
	},
});
